import { render } from "./StageComponent.vue?vue&type=template&id=6b4a2152&scoped=true&ts=true"
import script from "./StageComponent.vue?vue&type=script&lang=ts"
export * from "./StageComponent.vue?vue&type=script&lang=ts"

import "./StageComponent.vue?vue&type=style&index=0&id=6b4a2152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4a2152"]])

export default __exports__